import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=63b3202a&scoped=true&"
import script from "./PaymentOrder.vue?vue&type=script&lang=js&"
export * from "./PaymentOrder.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=63b3202a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3202a",
  null
  
)

export default component.exports